module.exports = __webpack_public_path__ + "static/media/handOpen_panoramic.15b1cccf.jpg";